import { diff } from 'jsondiffpatch';
export class History {
    _client;
    _historyStates = [];
    _nextHistoryCursor = 0;
    constructor(_client) {
        this._client = _client;
    }
    change(fn) {
        if (this._nextHistoryCursor < this._historyStates.length) {
            this._historyStates.splice(this._nextHistoryCursor);
        }
        const before = JSON.parse(JSON.stringify(this._client.getDoc()));
        this._client.change(fn);
        this._historyStates.push([before, JSON.parse(JSON.stringify(this._client.getDoc()))]);
        this._nextHistoryCursor++;
    }
    canUndo() {
        return this._nextHistoryCursor > 0 && Boolean(this._historyStates[Math.max(0, this._nextHistoryCursor - 1)]);
    }
    canRedo() {
        return this._nextHistoryCursor < this._historyStates.length && this._historyStates[this._nextHistoryCursor];
    }
    undo() {
        this._nextHistoryCursor = Math.max(0, this._nextHistoryCursor - 1);
        const entry = this._historyStates[this._nextHistoryCursor];
        if (!entry)
            return;
        this._applyChange(entry[1], entry[0]);
    }
    redo() {
        if (this._nextHistoryCursor >= this._historyStates.length)
            return;
        this._nextHistoryCursor++;
        const entry = this._historyStates[this._nextHistoryCursor - 1];
        if (!entry)
            return;
        this._applyChange(entry[0], entry[1]);
    }
    _applyChange(before, after) {
        const d = diff(JSON.parse(JSON.stringify(before)), JSON.parse(JSON.stringify(after)));
        if (!d)
            return;
        try {
            this._client.change(draft => {
                if (!applyDelta(d, draft)) {
                    throw new Error('Unable to apply undo/redo patch');
                }
            });
        }
        catch (err) {
            console.warn('Undo/redo threw error', err);
        }
    }
}
function applyDelta(d, obj) {
    if (typeof d !== 'object')
        return false;
    if (Array.isArray(obj) && d['_t'] === 'a')
        return applyArrayDelta(d, obj);
    else
        return applyObjectDelta(d, obj);
}
function applyObjectDelta(d, obj) {
    for (const [key, val] of Object.entries(d)) {
        if (Array.isArray(val)) {
            if (val.length === 1)
                obj[key] = val[0];
            else if (val.length === 2)
                obj[key] = val[1];
            else if (val.length === 3 && val[1] === 0 && val[2] === 0)
                delete obj[key];
        }
        else if (typeof val === 'object') {
            if (!applyDelta(val, obj[key]))
                return false;
        }
        else
            return false;
    }
    return true;
}
function applyArrayDelta(d, obj) {
    const toRemove = [];
    const toInsert = [];
    const toModify = [];
    for (const [key, val] of Object.entries(d)) {
        if (key === '_t')
            continue;
        if (!Array.isArray(val))
            return false;
        if (key[0] === '_') {
            if (val[2] === 0 || val[2] === 3)
                toRemove.push(parseInt(key.slice(1)));
        }
        else {
            if (val.length === 1)
                toInsert.push([parseInt(key), val[0]]);
            else
                toModify.push([parseInt(key), val]);
        }
    }
    toRemove.sort();
    for (let i = toRemove.length - 1; i >= 0; i--) {
        const indx = toRemove[i];
        const indexDiff = d[`_${indx}`];
        const removed = obj.splice(indx, 1)[0];
        if (indexDiff[2] === 3) {
            toInsert.push([indexDiff[1], removed]);
        }
    }
    toInsert.sort((a, b) => a[0] - b[0]);
    for (let i = 0; i < toInsert.length; i++) {
        const insertion = toInsert[i];
        obj.splice(insertion[0], 0, insertion[1]);
    }
    for (let i = 0; i < toModify.length; i++) {
        const mod = toModify[i];
        if (!applyDelta(mod[1], obj[mod[0]]))
            return false;
    }
    return true;
}
